const TRIAL_TYPE = 'trial'
const OPEN_TYPE = 'open'

const PENDING_STATUS = 'pending'
const APPROVED_STATUS = 'approved'
const DENIED_STATUS = 'denied'

export const applicationTypes = {
  TRIAL_TYPE,
  OPEN_TYPE
}

export const applicationStatuses = {
  PENDING_STATUS,
  APPROVED_STATUS,
  DENIED_STATUS
}



// WEBPACK FOOTER //
// ./src/views/Judges/constants.js